<template>
  <div>
    <nav-breadcrumb :menu="[{label: '进件作废'}]"/>
    <el-tabs v-model="applicationStatus">
      <el-tab-pane label="可作废" name="Approved" />
      <!-- <el-tab-pane label="审核通过" name="Approved" />-->
      <el-tab-pane label="已作废" name="Rejected" />
    </el-tabs>
    <div class="xzpadd10 bg-purple of">
      <data-table
        :table-data="tableData"
        :columns="columns"
        :page.sync="page"
        :pageSize.sync="pageSize"
        :filters.sync="filters"
        :actions="actions"
      />
    </div>
  </div>
</template>

<script>
  import xhr from '../../utils/xhr'
  import Status2CN from "../../filters/Status2CN";
  import moment from 'moment'
  import {xmlBuildQuery} from "../../filters/CommonActions";
    export default {
        name: "CustomerApplyingVoidList",
      data(){
        return{
          applicationStatus: 'Approved',
          roleData:{},
          dealerOptions:[],
          tableData: {
            count: 0,
            data: []
          },
          dealerTypeOptions:[],
          page: 1,
          pageSize: 20,
          actions: [
            /*{
              label: '新增',
              class: 'el-icon-plus',
              clickHandler: ()=>{
                this.$router.push({
                  path: 'add'
                })
              }
            }*/
          ],
          filters: {
            labelWidth: '150px',
            form: {
              ba__customerName:'',
              ba__customerContactNo:'',
              ba__customerIC:'',
              d__dealerId:'',
              t__applicationDate:[],
            },
            columns: [
              {
                label: '客户姓名',
                component: 'el-input',
                field: 'ba__customerName'
              },
             /* {
                label: '客户手机号',
                component: 'el-input',
                field: 'ba__customerContactNo'
              },*/
              {
                label: '身份证号码',
                component: 'el-input',
                field: 'ba__customerIC'
              },
              {
                label: '渠道商',
                component: 'el-select',
                field: 'd__dealerId',
                options:this.dealerOptions,
                span: 12
              },
              {
                label: '进件日期',
                component: 'date-range-picker',
                field: 't__applicationDate',
                op: ['gteq', 'lteq'],
                span: 12
              },



            ],
            onSubmit:()=>{
              this.page = 1
              this.getData()
            }
          }
        }
      },
      computed:{
        columns: function(){
          return [
            {
              type: 'index'
            },
            {
              label: '客户姓名',
              field: 'ba__customerName'
            },
           /* {
              label: '手机号',
              field: 'ba__customerContactNo'
            },*/
            {
              label: '身份证号码',
              field: 'ba__customerIC'
            },
            {
              label: '渠道商',
              field: 'd__dealerName'
            },
            /* {
               label: '客户来源',
               field: 'ba__channel'
             },*/
            {
              label: '进件时间',
              field: 't__applicationDate',
              formatter: function (r,c,v) {
                return moment(v).format('YYYY-MM-DD HH:mm')
              }
            },

            {
              label: '操作',
              opts:[
                {
                  label: '查看',
                  class: 'el-icon-view',
                  clickHandler: (index, row) => {
                    this.$router.push({
                      name: 'CustomerApplyingDetailView',
                      query: {
                        'applicationId': row.t__applicationId,
                      }
                    })
                  },
                  conditions: row=> {
                    return row.t__applicationStatus=='Rejected'

                  }
                },
                {
                  label: '作废',
                  class: 'el-icon-error',
                  clickHandler: (index, row) => {
                    this.voidApplyingCustomer(row.t__applicationId)
                  },
                  conditions: row=> {
                    return row.t__applicationStatus=='Approved'

                  }
                },

              ]
            }
          ]
        },
        filterParams: {
          get: function() {
            return {
              pageSize: this.pageSize,
              pageOffset: (this.page - 1) * this.pageSize,
              'xlist.search.t.applicationStatus' : this.applicationStatus,
              'xlist.search.t.applicationStatus.op' : 'in',
              'xlist.sort.dataField': 't.applicationDate',
              'xlist.sort.order': 'desc'
            }
          },
          set:function (newVal) {

          }
        }
      },
      watch: {
        filterParams: function () {
          this.getData()
        },
      },

      mounted() {
        this.getData()
        this.getDealerList()
      },
      methods: {
        getData: function () {
          xhr.getApplyingCustomerFangList(
            Object.assign({}, this.filterParams, xmlBuildQuery(this.filters)),
            res => {
              try {
                this.tableData = res.data
                this.roleData = res.data.variables
              } catch (e) {

              }
            })
        },
        getDealerList: function () {
          xhr.getDealerList(
            Object.assign({pageSize:0}, {}, {}),
            res=> {
              try {
                this.filters.columns[2].options = res.data.data.map(item=>{
                  return {
                    label: item.d__dealerName,
                    value:item.d__dealerId,
                  }
                })
              }catch(e){

              }
            })

        },


        voidApplyingCustomer: function (applicationId) {
          this.$confirm("确认要作废当前这笔进件吗？").then(()=> {
            xhr.voidApplyingCustomer(
              {
                't.applicationId':applicationId
              },
              res=> {
                try{
                  if(res.data.status == 'success') {
                    this.getData()
                  }else{

                    this.$message.error(res.data.msgs[0].text)
                  }
                }catch (e) {

                  this.$message.error(error.msgs[0].text)

                }
              }
            )
          })
            .catch(()=> {

            })


        },

      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/dealer/CustomerApplyingVoidList.vue